import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=bb105cf8&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=bb105cf8&lang=scss&scoped=true&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb105cf8",
  null
  
)

export default component.exports